const { default: RequestSupportApplyComponent } = require("../../components/request-support/request-support-apply");

const RequestSupportEditPage = () => <RequestSupportApplyComponent/>

export default RequestSupportEditPage;